(function (upp) {
    'use strict';

    //PLUGIN FOR MODULES:
    // * ESHOP
    // * CART
    // * PROMOTIONS

    upp.factory('product', function () {
        function Product(params) {
            this.id = params.id;
            this.name = params.name;
            this.category = params.category;
            this.brand = params.brand;
            this.attrName1 = params.attrName1;
            this.attrName2 = params.attrName2;
            this.attributes = params.attributes;
            this.description = params.description;
            this.addToBasket = params.addToBasket;
            this.features = params.features;
            this.files = params.files;
            this.preview = params.preview;
            this.promotions = params.promotions;
            this.tags = params.tags;
            this.price = params.price;
            this.priceFinal = params.priceFinal;
            this.selectedVariation = params.selectedVariation;
            this.selectedStock = params.selectedStock;
            this.noStock = false;
        }

        Product.prototype.isProductOrderOk = function () {
            return this.selectedStock &&
                this.selectedVariation &&
                this.maxStock >= this.selectedStock;
        };

        Product.prototype.hasAttributesAndStock = function () {
            return (this.selectedStock && typeof this.selectedStock !== 'undefined') &&
                (this.selectedVariation &&typeof this.selectedVariation !== 'undefined');
        };

        return Product;
    });

})(upp);


// WEBPACK FOOTER //
// ./src/app/plugins/products/factories/products-product-factory.js